import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

/*
  AiLimitBanner: the caption-sized warning banner shown wherever cached AI
  content is served because the daily generation allowance ran out. A
  warning-toned sibling of InfoBanner, sized down to fit inside dense
  insight cards — one definition so every AI surface flags stale content
  the same way.
*/
const AiLimitBanner = ({ children, sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 0.75,
      bgcolor: (theme) => alpha(theme.palette.warning.main, 0.12),
      borderRadius: 1,
      px: 1,
      py: 0.5,
      ...sx,
    }}
  >
    <WarningAmberRoundedIcon
      sx={{ fontSize: '0.9rem', color: 'warning.main', flexShrink: 0, mt: '2px' }}
    />
    <Typography variant="caption" sx={{ color: 'warning.dark', lineHeight: 1.5 }}>
      {children}
    </Typography>
  </Box>
);

export default AiLimitBanner;
